import { Field as ChakraField } from "@chakra-ui/react";
import { forwardRef } from "react";

export interface FieldProps
  extends React.ComponentProps<typeof ChakraField.Root> {
  label?: string;
  helperText?: React.ReactNode;
  errorText?: string;
  required?: boolean;
  invalid?: boolean;
}

export const Field = forwardRef<HTMLDivElement, FieldProps>(
  (
    { label, helperText, errorText, required, invalid, children, ...props },
    ref
  ) => {
    return (
      <ChakraField.Root ref={ref} invalid={invalid} {...props}>
        {label && (
          <ChakraField.Label>
            {label}
            {required && <ChakraField.RequiredIndicator />}
          </ChakraField.Label>
        )}
        {children}
        {helperText && !errorText && (
          <ChakraField.HelperText>{helperText}</ChakraField.HelperText>
        )}
        {errorText && (
          <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>
        )}
      </ChakraField.Root>
    );
  }
);

Field.displayName = "Field";
